import React from 'react';

export interface CloseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'sm' | 'md';
  ariaLabel?: string;
}

const sizeMap: Record<NonNullable<CloseButtonProps['size']>, number> = {
  sm: 28,
  md: 32,
};

export const CloseButton = ({
  size = 'md',
  ariaLabel = 'Cerrar',
  style,
  onMouseEnter,
  onMouseLeave,
  ...props
}: CloseButtonProps) => {
  const px = sizeMap[size];

  const handleMouseEnter = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.background = '#E5E8F1';
    e.currentTarget.style.color = '#001A70';
    onMouseEnter?.(e);
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.currentTarget.style.background = '#F5F7FA';
    e.currentTarget.style.color = '#6B7280';
    onMouseLeave?.(e);
  };

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        width: px,
        height: px,
        borderRadius: 8,
        border: '1px solid #E5E8F1',
        background: '#F5F7FA',
        color: '#6B7280',
        cursor: 'pointer',
        fontSize: size === 'sm' ? 14 : 16,
        fontWeight: 700,
        lineHeight: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        transition: 'background 0.15s, color 0.15s',
        ...style,
      }}
      {...props}
    >
      ×
    </button>
  );
};
